import { render, staticRenderFns } from "./ftp-detail.vue?vue&type=template&id=029fdc9e&scoped=true"
import script from "./ftp-detail.vue?vue&type=script&lang=js"
export * from "./ftp-detail.vue?vue&type=script&lang=js"
import style0 from "./ftp-detail.vue?vue&type=style&index=0&id=029fdc9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029fdc9e",
  null
  
)

export default component.exports